const tabComponents = document.getElementsByClassName('component-tabs');

[].forEach.call(tabComponents, tabComponent => {
    const tabList = tabComponent.querySelector('[role="tablist"]');
    const tabs = tabList.querySelectorAll('[role="tab"]');
    const panels = tabComponent.querySelectorAll('[role="tabpanel"]');

    [].forEach.call(tabs, tab => {
        tab.addEventListener('click', event => {
            event.preventDefault();

            const currentTab = tabList.querySelector('[aria-selected="true"]');

            if (event.target !== currentTab) {
                switchTab(currentTab, event.target);
            }
        });

        tab.addEventListener('keydown', event => {
            let index = [].indexOf.call(tabs, event.target);
            let direction = event.which === 37 ? 'left' : (event.which === 39 ? 'right' : (event.which === 40 ? 'down' : null));

            if (direction) {
                event.preventDefault();

                if (direction === 'down') {
                    panels[index].focus();
                } else {
                    const newTabIndex = direction === 'left' ? index - 1 : index + 1;

                    if (tabs[newTabIndex]) {
                        switchTab(event.target, tabs[newTabIndex]);
                    }
                }

            }
        });
    });

    const switchTab = (oldTab, newTab) => {
        oldTab.removeAttribute('aria-selected');
        oldTab.setAttribute('tabindex', '-1');

        newTab.removeAttribute('tabindex');
        newTab.setAttribute('aria-selected', 'true');
        newTab.focus();

        panels[[].indexOf.call(tabs, oldTab)].hidden = true;
        panels[[].indexOf.call(tabs, newTab)].hidden = false;

        window.events.emit('updateTab', newTab);

        history.pushState(null, null, new URL(newTab.href).hash);
    };

    const hash = window.location.hash;

    if (hash) {
        const newTab = tabList.querySelector('[href="' + hash + '"]');

        if (newTab) {
            switchTab(tabList.querySelector('[aria-selected="true"]'), newTab);
        }
    }
});
